import { ReactNode, useEffect, useRef, useState } from 'react'

interface IProps {
  children: ReactNode
  animationStyle: string
  threshold?: number
  rootMargin?: string
  triggerOnce?: boolean
}

export const AnimationContainer = ({ 
  children, 
  animationStyle, 
  threshold = 0.1, 
  rootMargin = '50px',
  triggerOnce = true 
}: IProps) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const [hasAnimated, setHasAnimated] = useState<boolean>(false)
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const currentElement = containerRef.current
    
    const callback = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !hasAnimated) {
          setIsVisible(true)
          if (triggerOnce) {
            setHasAnimated(true)
          }
        } else if (!triggerOnce && !entry.isIntersecting) {
          setIsVisible(false)
        }
      })
    }

    const observer = new IntersectionObserver(callback, {
      root: null,
      rootMargin,
      threshold,
    })

    if (currentElement) {
      observer.observe(currentElement)
    }

    return () => {
      if (currentElement) {
        observer.unobserve(currentElement)
      }
    }
  }, [hasAnimated, threshold, rootMargin, triggerOnce])

  return (
    <div 
      ref={containerRef} 
      className={`${(isVisible || hasAnimated) ? animationStyle : ''}`}
    >
      {children}
    </div>
  )
}